import { Checkbox, Group } from "@mantine/core"
import React, { Dispatch } from "react"
import { useTranslation } from "react-i18next"

import classes from "~/assets/css/Global.module.css"
import {
  FindIngestionSettingsResponseDto,
  findIngestionSettingsResponseDtoTraceabilityMethod,
  FindIngestionSettingsResponseDtoTraceabilityMethod,
} from "~/gen/api"

type TraceabilityMethod = FindIngestionSettingsResponseDtoTraceabilityMethod
const traceabilityMethodEnum =
  findIngestionSettingsResponseDtoTraceabilityMethod

type Props = {
  update: Dispatch<React.SetStateAction<FindIngestionSettingsResponseDto>>
  traceabilityMethod: TraceabilityMethod
}
export function TraceabilityMethods({ traceabilityMethod, update }: Props) {
  const { t } = useTranslation("organizationSettings")

  const handleCheck = (newMethod: TraceabilityMethod) => {
    update((prev) => ({ ...prev, traceabilityMethod: newMethod }))
  }

  return (
    <Group wrap="nowrap">
      <Group className={classes.panel} h={150} w="30%">
        <Checkbox
          label={t(
            "ingestionSettings.traceabilityMethod.options.default.title"
          )}
          description={t(
            "ingestionSettings.traceabilityMethod.options.default.description"
          )}
          checked={traceabilityMethod === traceabilityMethod}
          onChange={() => handleCheck(traceabilityMethodEnum.DEFAULT)}
        />
      </Group>
      <Group className={classes.panel} h={150} w="30%">
        <Checkbox
          label={t(
            "ingestionSettings.traceabilityMethod.options.traceabilityByPo.title"
          )}
          description={t(
            "ingestionSettings.traceabilityMethod.options.traceabilityByPo.description"
          )}
          checked={traceabilityMethod === traceabilityMethodEnum.PO}
          onChange={() => handleCheck(traceabilityMethodEnum.PO)}
        />
      </Group>
      <Group className={classes.panel} h={150} w="30%">
        <Checkbox
          label={t(
            "ingestionSettings.traceabilityMethod.options.multisourcing.title"
          )}
          description={t(
            "ingestionSettings.traceabilityMethod.options.multisourcing.description"
          )}
          checked={traceabilityMethod === traceabilityMethodEnum.MULTISOURCING}
          onChange={() => handleCheck(traceabilityMethodEnum.MULTISOURCING)}
        />
      </Group>
    </Group>
  )
}
